// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Form from "../components/Form.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as Title from "../components/Title.bs.js";
import * as React from "react";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Result from "rescript/lib/es6/belt_Result.js";
import * as ProfileLabel from "./ProfileLabel.bs.js";
import * as ProfileFamily from "./ProfileFamily.bs.js";
import * as ProfileGender from "./ProfileGender.bs.js";
import * as ProfileAddress from "./ProfileAddress.bs.js";
import * as ProfileContext from "./ProfileContext.bs.js";
import * as ProfileReducer from "./ProfileReducer.bs.js";
import * as ProfileBirthdate from "./ProfileBirthdate.bs.js";

var occupations = Belt_Array.map(ProfileLabel.arr_occupation, (function (x) {
        return {
                value: x,
                label: x
              };
      }));

function ProfileForm(Props) {
  var init_profile = Props.init_profile;
  var onValidateFormOpt = Props.onValidateForm;
  var is_editedOpt = Props.is_edited;
  var onValidateForm = onValidateFormOpt !== undefined ? onValidateFormOpt : (function (param) {
        
      });
  var is_edited = is_editedOpt !== undefined ? is_editedOpt : false;
  var match = React.useContext(ProfileContext.context);
  var reducer = match.reducer;
  var dispatch = reducer.dispatch;
  var state = reducer.state;
  var dispatchValue = function (action, x) {
    return Curry._1(dispatch, Curry._1(action, x.target.value));
  };
  React.useEffect((function () {
          Curry._1(dispatch, {
                TAG: /* ChangeState */0,
                _0: init_profile
              });
          
        }), []);
  React.useEffect((function () {
          var s = ProfileReducer.checkState(state);
          if (s.TAG === /* Ok */0) {
            var s$1 = s._0;
            Curry._1(onValidateForm, (function (param) {
                    return s$1;
                  }));
          } else {
            Curry._1(onValidateForm, (function (param) {
                    
                  }));
          }
          
        }), [state]);
  var onChangeDay = React.useCallback((function (x) {
          return Curry._1(dispatch, {
                      TAG: /* ChangeBirthdateDay */6,
                      _0: x
                    });
        }), [dispatch]);
  var onChangeMonth = React.useCallback((function (x) {
          return Curry._1(dispatch, {
                      TAG: /* ChangeBirthdateMonth */7,
                      _0: x
                    });
        }), [dispatch]);
  var onChangeYear = React.useCallback((function (x) {
          return Curry._1(dispatch, {
                      TAG: /* ChangeBirthdateYear */8,
                      _0: x
                    });
        }), [dispatch]);
  return React.createElement(React.Fragment, undefined, React.createElement(Title.make, {
                  text: "ข้อมูลส่วนตัว"
                }), React.createElement(Form.GroupInput.make, {
                  children: null
                }, React.createElement(Form.Label.make, {
                      text: "ชื่อ"
                    }), React.createElement(Form.InputText.make, {
                      value: ProfileReducer.getValue(state.firstname),
                      onChange: (function (param) {
                          return dispatchValue((function (x) {
                                        return {
                                                TAG: /* ChangeFirstName */1,
                                                _0: x
                                              };
                                      }), param);
                        }),
                      placeholder: ProfileLabel.placeholder_text.must_input,
                      error: Belt_Result.isError(state.firstname) ? ProfileLabel.err_text.firstname : undefined
                    })), React.createElement(Form.GroupInput.make, {
                  children: null
                }, React.createElement(Form.Label.make, {
                      text: "นามสกุล"
                    }), React.createElement(Form.InputText.make, {
                      value: ProfileReducer.getValue(state.lastname),
                      onChange: (function (param) {
                          return dispatchValue((function (x) {
                                        return {
                                                TAG: /* ChangeLastName */2,
                                                _0: x
                                              };
                                      }), param);
                        }),
                      placeholder: ProfileLabel.placeholder_text.must_input,
                      error: Belt_Result.isError(state.lastname) ? ProfileLabel.err_text.lastname : undefined
                    })), React.createElement(Form.GroupInput.make, {
                  children: React.createElement(ProfileBirthdate.make, {
                        birthdate: state.birthdate,
                        onChangeDay: onChangeDay,
                        onChangeMonth: onChangeMonth,
                        onChangeYear: onChangeYear,
                        disabled: is_edited
                      })
                }), React.createElement(Form.GroupInput.make, {
                  children: React.createElement(ProfileGender.make, {
                        gender: state.gender,
                        onChange: (function (gender) {
                            return Curry._1(dispatch, {
                                        TAG: /* ChangeGender */3,
                                        _0: gender
                                      });
                          }),
                        display: ProfileLabel.displayGender
                      })
                }), React.createElement(Form.GroupInput.make, {
                  children: null
                }, React.createElement(Form.Label.make, {
                      text: "เบอร์โทรศัพท์"
                    }), React.createElement(Form.InputText.make, {
                      value: ProfileReducer.getValue(state.mobile),
                      onChange: (function (param) {
                          return dispatchValue((function (x) {
                                        return {
                                                TAG: /* ChangeMobile */4,
                                                _0: x
                                              };
                                      }), param);
                        }),
                      placeholder: ProfileLabel.placeholder_text.must_input,
                      error: Belt_Result.isError(state.mobile) ? ProfileLabel.err_text.mobile : undefined,
                      inputMode: "numeric"
                    })), React.createElement(Form.GroupInput.make, {
                  children: null
                }, React.createElement(Form.Label.make, {
                      text: "อีเมล"
                    }), React.createElement(Form.InputText.make, {
                      value: ProfileReducer.getValue(state.email),
                      onChange: (function (param) {
                          return dispatchValue((function (x) {
                                        return {
                                                TAG: /* ChangeEmail */5,
                                                _0: x
                                              };
                                      }), param);
                        }),
                      placeholder: ProfileLabel.placeholder_text.option_input,
                      error: Belt_Result.isError(state.email) ? ProfileLabel.err_text.email : undefined
                    })), React.createElement(ProfileAddress.make, {
                  init_address: init_profile.address._0,
                  onChange: (function (addr) {
                      return Curry._1(dispatch, {
                                  TAG: /* ChangeAddress */10,
                                  _0: addr
                                });
                    })
                }), React.createElement(Form.GroupInput.make, {
                  children: null
                }, React.createElement(Form.Label.make, {
                      text: "อาชีพ"
                    }), React.createElement(Form.SelectWithInitialPlaceholder.make, {
                      placeholder: ProfileLabel.placeholder_text.must_choose,
                      data: occupations,
                      value: state.occupation,
                      onChange: (function (value) {
                          return Curry._1(dispatch, {
                                      TAG: /* ChangeOccupation */11,
                                      _0: value
                                    });
                        })
                    })), React.createElement(Form.GroupInput.make, {
                  children: React.createElement(ProfileFamily.make, {
                        family: state.family,
                        onChange: (function (t) {
                            return Curry._1(dispatch, {
                                        TAG: /* ChangeFamily */9,
                                        _0: t
                                      });
                          })
                      })
                }), React.createElement(Form.GroupInput.make, {
                  children: React.createElement("div", {
                        className: "space-y-2 pt-2"
                      }, React.createElement("div", {
                            className: "flex"
                          }, React.createElement(Form.Checkbox.make, {
                                checked: state.pdpa.privacy,
                                onChange: (function (param) {
                                    return Curry._1(dispatch, {
                                                TAG: /* ChangePDPA */12,
                                                _0: /* TogglePrivacyPolicy */0
                                              });
                                  })
                              }), React.createElement("div", {
                                className: "pl-2"
                              }, "ยินยอมให้บริษัท ไฮคิว ผลิตภัณฑ์อาหาร จำกัด จัดเก็บและประมวลผลข้อมูลส่วนบุคคล ตามที่ระบุอยู่ ", React.createElement("a", {
                                    href: "https://storage.googleapis.com/roza-public-assets/pdpa/roza_privacy_policy_20210625.pdf",
                                    rel: "noreferrer",
                                    target: "_blank"
                                  }, React.createElement("span", {
                                        className: "text-red underline"
                                      }, "นโยบายข้อมูลส่วนบุคคล")))), React.createElement("div", {
                            className: "flex"
                          }, React.createElement(Form.Checkbox.make, {
                                checked: state.pdpa.term,
                                onChange: (function (param) {
                                    return Curry._1(dispatch, {
                                                TAG: /* ChangePDPA */12,
                                                _0: /* ToggleTermAndCondition */1
                                              });
                                  })
                              }), React.createElement("div", {
                                className: "pl-2"
                              }, "ยอมรับ ", React.createElement("a", {
                                    href: "https://storage.googleapis.com/roza-public-assets/pdpa/RZA_Term_and_condition_Client_FINAL_Nowatermark_2021-05-30.pdf",
                                    rel: "noreferrer",
                                    target: "_blank"
                                  }, React.createElement("span", {
                                        className: "text-red underline"
                                      }, "ข้อตกลงและเงื่อนไขการให้บริการ")), " ของบริษัท ไฮคิว ผลิตภัณฑ์อาหาร จำกัด")))
                }));
}

var make = ProfileForm;

export {
  occupations ,
  make ,
  
}
/* occupations Not a pure module */
